import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Menu } from '@material/mwc-menu';

@customElement('company-menu')
export class CompanyMenu extends LitElement {
    static amplitude_callsite: string = 'Company Menu';



    @query('#cornerMenu')
    cornerMenu!: Menu;

    @query('#menuConnect')
    menuConnect!: HTMLDivElement;

    @property()
    organizationName?: string;

    @property({ type: Boolean })
    isAdmin: boolean = false;

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        this.cornerMenu.anchor = this.menuConnect;
    }

    private openMenu() {
        this.cornerMenu.open = true;
    }

    private goToTeamSettingsPage() {
        window.location.assign('/#team-settings');
    }

    protected render() {
        return html`
            <div style="position: relative">
                <div id="menuConnect" class="flexContainer">
                    <div class="companyName" @click=${this.openMenu}>
                        ${this.organizationName}
                        <div class="teamTag">Team</div>
                        ${this.isAdmin ? html`
                            <mwc-icon>expand_more</mwc-icon>
                        ` : ''}
                    </div>
                </div>
                ${this.isAdmin ? html`
                    <mwc-menu id="cornerMenu" fixed x="0" y="35">
                        <mwc-list-item>
                            <div class="flexContainer" @click=${this.goToTeamSettingsPage}>
                                <mwc-icon class="menuIcon">settings</mwc-icon>
                                <span>Workspace Settings</span>
                            </div>
                        </mwc-list-item>
                        <mwc-list-item>
                            <div class="flexContainer">
                                <mwc-icon class="menuIcon">logout</mwc-icon>
                                <span>Switch Teams</span>
                            </div>
                        </mwc-list-item>
                    </mwc-menu>
                ` : ''}
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --mdc-menu-min-width: min(100vw, 232px);
                --mdc-typography-subtitle1-font-size: 12px;
                --context-menu-color: var(--theme-input-color);
                --mdc-icon-button-size: 2.5rem;
            }

            .menuIcon {
                margin-right: 0.5rem;
                color: var(--context-menu-color);
                cursor: pointer;
            }

            mwc-list-item {
                --mdc-menu-item-height: 2.5rem;
                color: var(--context-menu-color);
            }

            mwc-list-item:hover {
                --context-menu-color: var(--main-primary-color);
                font-weight: 500;
            }

            .flexContainer {
                display: flex;
                align-items: center;
            }

            .companyName {
                border: 1px solid var(--main-primary-color);
                padding: 4px 4px 4px 12px;
                border-radius: 8px;
                font-size: 16px;
                margin-right: 1rem;
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            .teamTag {
                background: var(--main-featured-color);
                border-radius: 6px;
                padding: 3px 6px;
                margin-left: 12px;
                margin-right: 4px;
            }
        `;
    }
}
